import { FaTiktok, FaFacebookSquare, FaInstagram, FaPage4 } from 'react-icons/fa';
import { SiGoogleads } from 'react-icons/si';

import { TOption } from 'src/types/Commons/option.model';
import { SocialOption, SocialPageStatusName, SocialStatusName } from '../enums/socialMarketing';
import Label from 'src/components/Commons/Label';
import { MarketingIncurredType } from '../enums/marketingFeeActual';
import { BankTransactionStatusName } from '../enums/bank';
import { TIME_BETWEEN_TYPE, TIME_MONTH_TYPE, TIME_SEVEN_AGO, TIME_YEAR_TYPE } from '../constants/base';

export const listSourceType: TOption[] = [
  {
    label: 'Facebook',
    value: '1',
    icon: <FaFacebookSquare className="mr-2" />
  },
  {
    label: 'Google Ads',
    value: '2',
    icon: <SiGoogleads className="mr-2" />
  },
  {
    label: 'Tiktok',
    value: '3',
    icon: <FaTiktok className="mr-2" />
  },
  {
    label: 'Landing Page',
    value: '4',
    icon: <FaPage4 className="mr-2" />
  },
  {
    label: 'Instagram',
    value: '5',
    icon: <FaInstagram className="mr-2" />
  }
];
export const listOptionType: { label: string; value: SocialOption }[] = [
  {
    label: 'QA Quản lý',
    value: SocialOption.QA_Management
  },
  {
    label: 'Share QA BM',
    value: SocialOption.Share_QA_BM
  },
  {
    label: 'Add group',
    value: SocialOption.AddGroup
  },
  {
    label: 'Share QA TKQC',
    value: SocialOption.Share_QA_TKQC
  },
  {
    label: 'Khác',
    value: SocialOption.Other
  }
];
export const getSocialOption = (option: number) => listOptionType.find(x => x.value == option);
export const getSocialStatusLabel = (status: SocialStatusName, language: any): JSX.Element => {
  const map = {
    Pending: {
      text: language.common.status.pending,
      color: 'warning'
    },
    Approved: {
      text: language.common.status.approve,
      color: 'success'
    },
    Reject: {
      text: language.common.status.reject,
      color: 'error'
    },
    Block: {
      text: language.common.status.block,
      color: 'primary'
    },
    PermanentlyBlock: {
      text: language.common.status.permanentlyBlock,
      color: 'info'
    },
    QAApproved: {
      text: 'QA Approved',
      color: 'info'
    },
    WaitingBlock: {
      text: 'Yêu cầu khóa',
      color: 'error'
    },
    ApproveBlock: {
      text: 'Chờ khóa',
      color: 'info'
    }
  };

  const { text, color }: any = map[status];
  return <Label color={color}>{text}</Label>;
};

export const getSocialLabel = (type: number) => {
  const source = listSourceType.find(x => x.value === `${type}`);
  return (
    <span>
      {source?.icon} {source?.label}
    </span>
  );
};

export const getSocialPageStatus = (status: SocialPageStatusName, language: any): JSX.Element => {
  const map = {
    activated: {
      text: language.common.status.activated,
      color: 'success'
    },
    inactivated: {
      text: language.common.status.inActivated,
      color: 'error'
    }
  };

  const { text, color }: any = map[status];
  return <Label color={color}>{text}</Label>;
};

export const getMarketingIncurredType = (type?: MarketingIncurredType) => {
  const getItem = listMarketingIncurredType.find(x => x.value === `${type}`);
  return <span>{getItem?.label}</span>;
};

export const listMarketingIncurredType: TOption[] = [
  {
    label: 'Thuế nhà thầu',
    value: '2'
  },
  {
    label: 'Chi phí ngân hàng',
    value: '3'
  },
  {
    label: 'Phí thuê tài khoản',
    value: '4'
  },
  {
    label: 'Phí khác',
    value: '5'
  },
  {
    label: 'Phí tài nguyên',
    value: '6'
  },
  {
    label: 'Phí production',
    value: '7'
  }
];

export const listOptionSocialReason: TOption[] = [
  {
    value: '1',
    label: 'Page die'
  },
  {
    value: '2',
    label: 'TKQC die'
  },
  {
    value: '3',
    label: 'Song song'
  }
];

export const getBankTransactionStatusLabel = (status: BankTransactionStatusName): JSX.Element => {
  const map = {
    draft: {
      text: 'Chờ xác nhận',
      color: 'warning'
    },
    confirm: {
      text: 'Đã xác nhận',
      color: 'success'
    },
    reject: {
      text: 'Từ chối',
      color: 'error'
    }
  };

  const { text, color }: any = map[status];
  return <Label color={color}>{text}</Label>;
};

export const listBankTransactionStatus: TOption[] = [
  {
    label: 'Tất cả',
    value: ''
  },
  {
    label: 'Chờ xác nhận',
    value: '0'
  },
  {
    label: 'Đã xác nhận',
    value: '1'
  },
  {
    label: 'Từ chối',
    value: '2'
  }
];
export const listRevenueType: TOption[] = [
  {
    label: '7 ngày trước',
    value: `${TIME_SEVEN_AGO}`
  },
  {
    label: 'Tuần trước',
    value: '5'
  },
  {
    label: 'Tuần này',
    value: '6'
  },
  {
    label: 'Tháng trước',
    value: '7'
  },
  {
    label: 'Tháng hiện tại',
    value: '8'
  },
  {
    label: 'Năm trước',
    value: '9'
  },
  {
    label: 'Năm hiện tại',
    value: '10'
  },
  {
    label: 'Tháng',
    value: `${TIME_MONTH_TYPE}`
  },
  {
    label: 'Năm',
    value: `${TIME_YEAR_TYPE}`
  },
  {
    label: 'Theo khoảng thời gian',
    value: `${TIME_BETWEEN_TYPE}`
  }
];
export const listCustomerType: TOption[] = [
  {
    label: 'Tất cả',
    value: '-1'
  },
  {
    label: 'Khách mới',
    value: '0'
  },
  {
    label: 'Khách cũ',
    value: '1'
  }
];
export const listDeliveryStatus = [
  { value: '0', label: 'Tất cả' },
  { value: '1', label: 'Đơn hàng thành công' },
  { value: '2', label: 'Đơn đang giao hàng' }
] as TOption[];
